import React from "react";
import LoadingWrapper from "../styles"

const Loading =()=>(
<LoadingWrapper>
<div className="loading">
</div>
</LoadingWrapper>
);

export default Loading;